/* meowsh™ — özel bölüm etkileşimleri */
const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/* ---------- Reveal ---------- */
let revealObserver = null;
function initReveal(scope) {
  const els = scope.querySelectorAll('.mw-reveal:not(.is-in)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-in'));
    return;
  }
  if (!revealObserver) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }
  els.forEach((el) => revealObserver.observe(el));
}

/* ---------- Gallery ---------- */
function initGallery(scope) {
  scope.querySelectorAll('[data-mw-gallery]').forEach((gallery) => {
    if (gallery.dataset.mwReady) return;
    gallery.dataset.mwReady = '1';
    const track = gallery.querySelector('.mw-gallery__track');
    if (!track) return;
    const slides = Array.from(track.children);
    const thumbs = Array.from(gallery.querySelectorAll('.mw-gallery__thumb'));
    const dots = Array.from(gallery.querySelectorAll('.mw-gallery__dots span'));
    const thumbWrap = gallery.querySelector('.mw-gallery__thumbs');
    let current = 0;

    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      const t = thumbs[i];
      if (t && thumbWrap) {
        const left = t.offsetLeft - thumbWrap.clientWidth / 2 + t.clientWidth / 2;
        thumbWrap.scrollTo({ left, behavior: 'smooth' });
      }
      slides.forEach((s, j) => {
        if (j !== i) s.querySelectorAll('video').forEach((v) => v.pause());
      });
    };
    const go = (i) => {
      const n = slides.length;
      const idx = ((i % n) + n) % n;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      setActive(idx);
    };

    let raf = 0;
    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        });
      },
      { passive: true }
    );
    thumbs.forEach((t, j) => t.addEventListener('click', () => go(j)));
    gallery.querySelector('.mw-gallery__nav--prev')?.addEventListener('click', () => go(current - 1));
    gallery.querySelector('.mw-gallery__nav--next')?.addEventListener('click', () => go(current + 1));
    setActive(0);
  });
}

/* ---------- Bundle + cart ---------- */
async function loadCartEvent() {
  try {
    const mod = await import('@shopify/events');
    return mod && mod.CartLinesUpdateEvent ? mod.CartLinesUpdateEvent : null;
  } catch (e) {
    return null;
  }
}

function showError(form, msg) {
  const box = form.querySelector('.mw-buy__error');
  if (!box) return;
  box.textContent = msg || 'Bir sorun oluştu, lütfen tekrar deneyin.';
  box.classList.add('is-visible');
  setTimeout(() => box.classList.remove('is-visible'), 6000);
}

/* Sepete eklenecek ürün notları (ör. properties[Hediye]) */
function getLineProperties(form) {
  const props = {};
  form.querySelectorAll('[name^="properties["]').forEach((input) => {
    if (input.disabled || !input.value) return;
    props[input.name.slice(11, -1)] = input.value;
  });
  return props;
}

async function addToCart(form, button) {
  const idInput = form.querySelector('[name="id"]');
  const qtyInput = form.querySelector('[name="quantity"]');
  if (!idInput) return;
  const id = Number(idInput.value);
  const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
  const buttons = [button, ...document.querySelectorAll(`[form="${form.id}"][type="submit"]`)].filter(Boolean);
  buttons.forEach((b) => b.classList.add('is-loading'));

  const CartEvent = await loadCartEvent();
  let deferred = null;
  if (CartEvent && typeof CartEvent.createPromise === 'function') {
    try {
      deferred = CartEvent.createPromise();
      form.dispatchEvent(
        new CartEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity }],
          promise: deferred.promise,
        })
      );
    } catch (e) {
      deferred = null;
    }
  }

  try {
    const properties = getLineProperties(form);
    const item = Object.keys(properties).length ? { id, quantity, properties } : { id, quantity };
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi');

    const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

    if (deferred) {
      const cartPayload = typeof CartEvent.createCartFromAjaxResponse === 'function' ? CartEvent.createCartFromAjaxResponse(cart) : cart;
      deferred.resolve({
        cart: cartPayload,
        detail: { items: cart.items, source: 'mw-product', itemCount: quantity, productId: form.dataset.productId, didError: false },
      });
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer) {
        window.location.href = `${ROOT}cart`;
      } else {
        setTimeout(() => {
          const dlg = drawer.closest('theme-drawer');
          if (dlg && !dlg.hasAttribute('open') && typeof dlg.open === 'function') dlg.open();
        }, 450);
      }
    } else {
      window.location.href = `${ROOT}cart`;
    }
  } catch (err) {
    if (deferred) {
      try { deferred.reject(err); } catch (e) {}
    }
    showError(form, err && err.message);
  } finally {
    buttons.forEach((b) => b.classList.remove('is-loading'));
  }
}

function initProduct(scope) {
  scope.querySelectorAll('[data-mw-product]').forEach((section) => {
    if (section.dataset.mwReady) return;
    section.dataset.mwReady = '1';
    const form = section.querySelector('form[data-mw-form]');
    if (!form) return;
    const qtyInput = form.querySelector('[name="quantity"]');
    const totals = section.querySelectorAll('[data-mw-total]');
    const tiers = Array.from(section.querySelectorAll('.mw-tier'));

    const sync = () => {
      const checked = section.querySelector('.mw-tier input:checked');
      tiers.forEach((t) => t.classList.toggle('is-selected', t.contains(checked)));
      if (!checked) return;
      if (qtyInput) qtyInput.value = checked.value;
      const label = checked.dataset.total;
      if (label) totals.forEach((el) => (el.textContent = label));
    };
    section.querySelectorAll('.mw-tier input').forEach((input) => input.addEventListener('change', sync));
    sync();

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart(form, event.submitter || form.querySelector('[type="submit"]'));
    });

    section.querySelectorAll('[data-mw-buy-now]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = form.querySelector('[name="id"]').value;
        const qty = (qtyInput && qtyInput.value) || 1;
        btn.classList.add('is-loading');
        const permalink = `${ROOT}cart/${id}:${qty}`;
        const properties = getLineProperties(form);
        if (!Object.keys(properties).length) {
          window.location.href = permalink;
          return;
        }
        // Hediye notu siparişe de düşsün: sepeti ürün + notla hazırla, sonra ödemeye geç
        fetch(`${ROOT}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } })
          .then(() =>
            fetch(`${ROOT}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty), properties }] }),
            })
          )
          .then((res) => {
            if (!res.ok) throw new Error('add');
            window.location.href = `${ROOT}checkout`;
          })
          .catch(() => {
            window.location.href = permalink;
          });
      });
    });

    const sticky = section.querySelector('.mw-sticky');
    const anchor = section.querySelector('.mw-buy');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const past = entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && past);
      });
      io.observe(anchor);
    }
  });
}

/* ---------- Video toggles ---------- */
function initVideos(scope) {
  scope.querySelectorAll('[data-mw-video-toggle]').forEach((btn) => {
    if (btn.dataset.mwReady) return;
    btn.dataset.mwReady = '1';
    const video = btn.parentElement.querySelector('video');
    if (!video) return;
    const update = () => btn.classList.toggle('is-playing', !video.paused);
    btn.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    update();
  });
}

function initAll(scope = document) {
  initGallery(scope);
  initProduct(scope);
  initVideos(scope);
  initReveal(scope);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}
window.__mwReady = true;

document.addEventListener('shopify:section:load', (e) => initAll(e.target));
